/**
 * Putting a product list in the order a person would look things up in.
 *
 * The catalogue's own order is `sort_order, name`, which is deliberate at the
 * till — the grid is arranged with what sells most within thumb's reach. In a
 * dropdown of every product it is no help at all: you are reading down a list
 * hunting for a name, and the only order that helps is the one the alphabet
 * gives you.
 *
 * It reads worse than it should, too. Nothing in the app ever sets a product's
 * `sort_order`, so every product added since the original catalogue was keyed
 * in carries the default 0. They all tie, sort alphabetically among themselves,
 * and land as a neat A–Z block in front of the whole original list — which
 * then carries on in its own hand-made order. Half-sorted looks like a bug
 * even though both halves are behaving.
 *
 * Compared with a collator rather than `<`, so that case and punctuation do
 * not decide anything ("Cheese 'n Herbs" beside "Cheesy"), and so numbers in a
 * name count as numbers: box of 6 comes before box of 12, where plain text
 * ordering would put 12 first.
 */

const collator = new Intl.Collator('en', { sensitivity: 'base', numeric: true });

/** A copy of `items`, in the order a person would look them up in. */
export function byName<T extends { name: string }>(items: readonly T[]): T[] {
  return [...items].sort((a, b) => collator.compare(a.name, b.name));
}
